export const state = {
	message: '',
	type: '',
	status: false
}

export const mutations = {
	TOGGLE_NOTIFICATION_BANNER (state, {status, message = '', type = ''}) {
		state.message = message
		state.type = type
		state.status = status
	}
}

export const actions = {
	async toggleNotificationBanner ({ commit }, payload) {
		commit('TOGGLE_NOTIFICATION_BANNER', payload)
	}
}

export const getters = {
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/global/notification-banner.js